// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2SBLA","question":"Question_question__3cnX7","description":"Question_description__2Kcv4"};